import { render, staticRenderFns } from "./QnBin.vue?vue&type=template&id=2acced96&scoped=true&"
import script from "./QnBin.vue?vue&type=script&lang=js&"
export * from "./QnBin.vue?vue&type=script&lang=js&"
import style0 from "./QnBin.vue?vue&type=style&index=0&id=2acced96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acced96",
  null
  
)

export default component.exports